import { useNavigate } from "react-router-dom";
import {
  getLocal,
  NFeDto,
  NFeCadastroTransporteDto,
  STORAGENFE_KEY,
  updateLocal,
} from "../NFe.Dto";
import { Button, Col, Container, Row } from "react-bootstrap";

const NFeCadastroModalidadeFreteView = () => {
  const navigate = useNavigate();

  const getTransporteSelecionado = (): NFeCadastroTransporteDto => {
    return (
      getLocal<NFeDto>(STORAGENFE_KEY)?.transporte ??
      ({
        modalidadeFrete: undefined,
      } as NFeCadastroTransporteDto)
    );
  };

  const transporte = getTransporteSelecionado();

  const selecionado = transporte.modalidadeFrete != undefined;

  const handleSalvar = (modalidade: number) => () => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      transporte: {
        ...transporte,
        modalidadeFrete: modalidade,
      },
    });
    navigate("../transporte");
  };

  const handleVoltar = () => () => {
    navigate("../pagamento");
  };

  const handleProximo = () => {
    navigate("../transporte");
  };

  const buttonVariant = (modalidade: number) => {
    const frete = transporte;

    if (frete === undefined || frete.modalidadeFrete === modalidade) {
      return "primary";
    }

    return "outline-primary";
  };

  const modalidades = [
    { id: 0, label: "Contratação do Frete por conta do Remetente (CIF)" },
    { id: 1, label: "Contratação do Frete por conta do Destinatário (FOB)" },
    { id: 2, label: "Contratação do Frete por conta de Terceiros" },
    { id: 3, label: "Transporte Próprio por conta do Remetente" },
    { id: 4, label: "Transporte Próprio por conta do Destinatário" },
    { id: 9, label: "Sem Ocorrência de Transporte" },
  ];

  return (
    <>
      {modalidades.map((m) => (
        <Row key={m.id}>
          <Col xs={12} className="d-grid mt-3">
            <Button
              type="submit"
              onClick={handleSalvar(m.id)}
              variant={buttonVariant(m.id)}
            >
              {m.label}
            </Button>
          </Col>
        </Row>
      ))}
      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={!selecionado ? 12 : 6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar()}>
                Voltar
              </Button>
            </Col>
            {selecionado && (
              <Col xs={6} className="d-grid">
                <Button
                  variant="outline-primary"
                  type="submit"
                  onClick={handleProximo}
                >
                  Próximo
                </Button>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};
export default NFeCadastroModalidadeFreteView;
